import PropTypes from 'prop-types';
import NavLink from './NavLink';
export default {
  account: PropTypes.shape({
    username: PropTypes.string.isRequired,
    avatar: PropTypes.string
  }),
  onMenuItemClick: PropTypes.func,
  mainLinkGroups: PropTypes.arrayOf(PropTypes.shape(NavLink)),
  accountLinkGroups: PropTypes.arrayOf(PropTypes.shape(NavLink)),
  showSocialIcons: PropTypes.bool,
  activeHrefKey: PropTypes.string,
  identityHost: PropTypes.string,
  consumerHost: PropTypes.string,
  payHost: PropTypes.string
};